import { HSOverlay, ICollectionItem } from "preline";
import { CreateWorkspaceForm } from "./CreateWorkspaceForm";

export function CreateWorkspaceModal() {
  const children = {
    createWorkspaceForm: CreateWorkspaceForm({ closeParentModal: close }),
  };

  let $modalElem: null | HTMLElement = null;

  function init() {
    $modalElem = document.getElementById("create-workspace-modal");

    // reset the create workspace form on modal close
    HSOverlay.autoInit();
    const modalCloseBtn = $modalElem?.querySelector('[data-hs-overlay="#create-workspace-modal"]') as HTMLElement;
    const el = HSOverlay.getInstance(modalCloseBtn, true) as ICollectionItem<HSOverlay>;
    el?.element?.on('close', () => {
      children.createWorkspaceForm.resetForm();
    });
  }

  function open() {
    if ($modalElem)
      HSOverlay.open($modalElem);
  }

  function close() {
    if ($modalElem){
      HSOverlay.close($modalElem);
      const workspaceModalBackDrop = document.getElementById("create-workspace-modal-backdrop");
      if (workspaceModalBackDrop) {
        workspaceModalBackDrop.remove();
      }
    }
  }

  function render() {
    return /*html*/`
    <div id="create-workspace-modal"
      class="hs-overlay hidden size-full fixed top-0 start-0 z-[80] overflow-x-hidden overflow-y-auto [--body-scroll:true] pointer-events-none"
      role="dialog" tabindex="-1" aria-labelledby="create-workspace-modal-label">
      <div
        class="hs-overlay-animation-target hs-overlay-open:scale-100 hs-overlay-open:opacity-100 scale-95 opacity-0 ease-in-out transition-all duration-200 sm:max-w-lg sm:w-full m-3 sm:mx-auto min-h-[calc(100%-3.5rem)] flex items-center">
        <div
          class="w-full flex flex-col bg-white border shadow-sm rounded-xl pointer-events-auto dark:bg-neutral-800 dark:border-neutral-700 dark:shadow-neutral-700/70">
          <!-- Header -->
          <div class="flex justify-between items-center py-3 px-4 border-b dark:border-neutral-700">
            <h3 id="create-workspace-modal-label" class="font-bold text-gray-800 dark:text-white">
              Create New Workspace
            </h3>
            <button type="button"
              class="size-8 inline-flex justify-center items-center gap-x-2 rounded-full border border-transparent bg-gray-100 text-gray-800 hover:bg-gray-200 focus:outline-none focus:bg-gray-200 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-700 dark:hover:bg-neutral-600 dark:text-neutral-400 dark:focus:bg-neutral-600"
              aria-label="Close" data-hs-overlay="#create-workspace-modal">
              <span class="sr-only">Close</span>
              <svg class="shrink-0 size-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M18 6 6 18"></path>
                <path d="m6 6 12 12"></path>
              </svg>
            </button>
          </div>
          <!-- End Header -->

          <!-- Create workspace Form -->
          ${children.createWorkspaceForm.render()}
        </div>
      </div>
    </div>
    `;
  }

  return { init, render, open, close, children };
}